import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppConfiguration } from '../config/app-configuration';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private pendingHTTPRequests$ = new Subject<void>();

    constructor(private router: Router, private appConfig: AppConfiguration) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (localStorage.getItem('token') != null) {
            if (req.url == this.appConfig.urlInformation) {
                const clonedReq = req.clone({
                    headers: req.headers.set("Authorization", "Basic " + btoa(this.appConfig.polarixapiuser + ":" + this.appConfig.polarixapipass),)
                });
                return next.handle(clonedReq).pipe(
                    tap(
                        succ => { },
                        err => {
                            if (err.status === 401) {
                                localStorage.removeItem('token');
                                this.router.navigateByUrl('/login');
                            }
                        }
                    )
                );

            } else {
                const clonedReq = req.clone({
                    headers: req.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
                    // headers: req.headers.set('Authorization', 'Bearer ' + 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJVc2VySUQiOiIyOSIsIkRCTkFNRSI6ImN1YmUiLCJDTElFTlRJUCI6IjEzOC4xMjIuNS45NCIsIlRFUk1TQUNDRVBURUQiOiJUcnVlIiwibmJmIjoxNjU3NTY1NzUzLCJleHAiOjE2NTc2NTIxNTMsImlhdCI6MTY1NzU2NTc1M30.5hWnJ4Sh4_cmPuAAi8Dbpce1Iyuvzuieg9njDyjFK7s')
                });
                return next.handle(clonedReq).pipe(
                    takeUntil(this.pendingHTTPRequests$.asObservable()),
                    tap(
                        succ => { },
                        err => {
                            if (err.status === 401) {
                                localStorage.removeItem('token');
                                this.router.navigateByUrl('/login');
                            }
                        }
                    )
                );
            }
        } else {
            // eliminar esto 
            const clonedReq = req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
                // headers: req.headers.set('Authorization', 'Bearer ' + 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJVc2VySUQiOiIyOSIsIkRCTkFNRSI6ImN1YmUiLCJDTElFTlRJUCI6IjEzOC4xMjIuNS45NCIsIlRFUk1TQUNDRVBURUQiOiJUcnVlIiwibmJmIjoxNjU3NTY1NzUzLCJleHAiOjE2NTc2NTIxNTMsImlhdCI6MTY1NzU2NTc1M30.5hWnJ4Sh4_cmPuAAi8Dbpce1Iyuvzuieg9njDyjFK7s')
            });
            return next.handle(clonedReq).pipe(
                takeUntil(this.pendingHTTPRequests$.asObservable()),
                tap(
                    succ => { },
                    err => {
                        if (err.status === 401) {
                            localStorage.removeItem('token');
                            this.router.navigateByUrl('/login');
                        }
                    }
                )
            );
            // +++++++++++++++++
                
            // descomentar esto
            // return next.handle(req.clone());
        }
    }
}
